<div class="template-name">
  <ng-content></ng-content>
</div>
